export default "__VITE_ASSET__8f380fd5__"